import { selectAll } from 'css-select';
import type { Element, Node } from 'domhandler';
import { parseDocument } from 'htmlparser2';

type ChangeMediaType = 'image' | 'youtube';

type Result = Record<ChangeMediaType, number>;

export function getMediaCount(encodedHtml: string): Result {
	const document = parseDocument(encodedHtml);

	const changeMedia = selectAll<Node, Element>('change-media', document);
	const youtube = changeMedia.filter((el) => el.attribs['data-type'] === 'youtube').length;
	const image = changeMedia.filter((el) => el.attribs['data-type'] === 'img').length;

	return {
		image,
		youtube,
	};
}
